import React from 'react';
import { Header } from '@/components/site/Header';
import { Hero } from '@/components/site/Hero';
import { Marquee } from '@/components/site/Marquee';
import { LoreChapters } from '@/components/site/LoreChapters';
import { Tokenomics } from '@/components/site/Tokenomics';
import { GoldRoom } from '@/components/site/GoldRoom';
import { ContractSection } from '@/components/site/ContractSection';
import { Gallery } from '@/components/site/Gallery';
import { CommunityBand } from '@/components/site/Social';
import { Footer } from '@/components/site/Footer';

export default function Home() {
  return (
    <div className="grain min-h-screen w-full max-w-full min-w-0 overflow-x-hidden [overflow-x:clip] bg-background text-foreground">
      <Header />
      <main className="w-full max-w-full min-w-0 overflow-x-hidden [overflow-x:clip]">
        <Hero />
        <Marquee />
        <LoreChapters />
        <Tokenomics />
        <GoldRoom />
        <ContractSection />
        <Gallery />
        <CommunityBand />
      </main>
      <Footer />
    </div>
  );
}
